import React from 'react'
import tw from 'tailwind-styled-components'
import {Pagination} from './pagination'

const TwPagination = tw.div`
  box-border
  absolute
  flex
  items-end
  gap-8
  transform
  -translate-x-1/2
  bottom-16
  left-1/2
`

export const FilePreviewer = () => {
  return (
    <TwPagination>
      <Pagination />
    </TwPagination>
  )
}
